import { MAT_DATE_LOCALE } from '@angular/material/core';
import { Optional, Inject, Injectable } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

import { BitfDateAdapterService } from '@bitf/services/locale/bitf-date-adapter.service';
import { BitfDynamicLocaleService } from '@common/libs/bitforce/core/services/locale/bitf-dynamic-locale.service';

@Injectable()
export class DateAdapterService extends BitfDateAdapterService {
  defaultFormat = 'yyyy-MM-dd';
  firstDayMap = {
    it: 1,
    en: 1,
  };
  localeFormatMap = {
    it: 'dd/MM/yyyy',
    en: 'dd/MM/yyyy',
  };

  constructor(
    @Optional() @Inject(MAT_DATE_LOCALE) matDateLocale: string,
    platform: Platform,
    protected bitfDynamicLocaleService: BitfDynamicLocaleService
  ) {
    super(matDateLocale, platform, bitfDynamicLocaleService);
  }
}
